import { ResourceUsageContent } from "@/components/environments/EnvironmentPerformance";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/podkit/dialog/Dialog";
import { useVMLiveUsage } from "@/hooks/use-vm-live-usage";
import { TrackLocations } from "@/hooks/use-segment";
import { useEnvironment } from "@/queries/environment-queries";
import type { FC } from "react";

type ResourceUsageDialogProps = {
    environmentId: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const ResourceUsageDialog: FC<ResourceUsageDialogProps> = ({ environmentId, open, onOpenChange }) => {
    const { data, diskIORate, error, isLoading, lastUpdated, refetch } = useVMLiveUsage(environmentId, open);
    const { data: environment } = useEnvironment(environmentId);
    const projectId = environment?.metadata?.projectId;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-track-location={TrackLocations.ResourceUsageModal}>
                <DialogHeader>
                    <DialogTitle>Resource Usage</DialogTitle>
                </DialogHeader>
                <ResourceUsageContent
                    data={data}
                    diskIORate={diskIORate}
                    error={error}
                    isLoading={isLoading}
                    lastUpdated={lastUpdated}
                    onRefresh={refetch}
                    projectId={projectId}
                />
            </DialogContent>
        </Dialog>
    );
};
